import { FC, ReactNode } from "react";
import styles from "./Section.module.scss";

export interface SectionProps {
  children: ReactNode;
  bgColor?: "white" | "off-white" | "transparent";
  fullWidthContent?: boolean;
  sectionClass?: string;
}

const bgClassMap = {
  white: styles["bg-white"],
  "off-white": styles["bg-off-white"],
  transparent: "",
};

const Section: FC<SectionProps> = ({
  children,
  bgColor = "transparent",
  fullWidthContent = false,
  sectionClass = "",
}) => {
  const sectionClasses =
    `${styles.outer} ${bgClassMap[bgColor]} ${sectionClass}`.trim();

  return (
    <section className={sectionClasses}>
      {fullWidthContent ? (
        children
      ) : (
        <div className={styles.inner}>{children}</div>
      )}
    </section>
  );
};

export default Section;
